import React, { FC } from 'react';

import useFCMService from '~/libs/hooks/useFCMService';

const FCMRegister: FC = () => {
    // FCM 토큰 연결
    useFCMService();

    return null;
};

export default FCMRegister;
